import { FC } from 'react';
import { ReactComponent as IconThumbUp } from "../../../assets/icons/thumb-up-solid.svg";
import './ArticleVote.scss';
import { useArticles } from '../../../providers/Articles/ArticlesProvider';

interface ArticleVoteProps {
  articleId: number;
}

const ArticleVote: FC<ArticleVoteProps> = ({ articleId }) => {
  const { articleVote, isLoadingVote, handleVote } = useArticles();

  return (
    <div className="ArticleVote" data-testid="ArticleVote">
      <p className="text-sm">Este artigo foi útil?</p>
      <div className="d-flex align-items-center gap-1">
        <button
          className={`btn btn-transparent ${!!articleVote && articleVote?.vote ? 'active' : ''}`}
          disabled={!!articleVote || isLoadingVote}
          onClick={() => { handleVote(articleId, true) }}
          title='Marcar como útil'
        >
          {isLoadingVote ? (
            <div className="spinner-border spinner-border-sm" aria-hidden="true"></div>
          ) : (
            <IconThumbUp width={24} fill={`${!!articleVote && articleVote?.vote ? '#2c2a4e' : '#fff'}`} />
          )}
        </button>
        <button
          className={`btn btn-transparent ${!!articleVote && !articleVote?.vote ? 'active' : ''}`}
          disabled={!!articleVote || isLoadingVote}
          onClick={() => { handleVote(articleId, false) }}
          title='Marcar como não útil'
        >
          {isLoadingVote ? (
            <div className="spinner-border spinner-border-sm" aria-hidden="true"></div>
          ) : (
            <IconThumbUp width={24} className={`thumb-down`} fill={`${!!articleVote && !articleVote?.vote ? '#2c2a4e' : '#fff'}`} />
          )}
        </button>
      </div>
    </div>
  );
}

export default ArticleVote;
